import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl"></i>
            </div>
            <span className="text-lg font-bold whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              韩漫阅读
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap"
            >
              更多
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 rounded-md hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 space-y-1">
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="block px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors"
            >
              全部分类
            </Link>
            <hr className="border-background-200/70 my-2" />
            <Link
              to="/about"
              className="block px-3 py-2.5 text-sm text-foreground-600 hover:text-foreground-950 rounded-md transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}